import { faLoveseat } from "@fortawesome/pro-solid-svg-icons";
import {
  V2ListResourceRatesForAccountApiArg,
  V2ResourceRateResource,
  V2ResourceResource,
  useV2ListResourceRatesForAccountQuery,
} from "@generated";

export interface HookArgs {
  resources: V2ResourceResource[];
  filter: V2ListResourceRatesForAccountApiArg["filter"];
}

const useResourceRates = ({ resources = [], filter }: HookArgs) => {
  const {
    data,
    error: resourceRatesError,
    isLoading: resourceRatesLoading,
    refetch: resourceRatesRefetch,
  } = useV2ListResourceRatesForAccountQuery({
    page: { size: 1000 },
    include: ["line-of-business"],
    filter,
  });

  let resourceRates: V2ResourceRateResource[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      resourceRates = data?.data;

      if (!data?.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data?.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data?.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data?.meta["record-count"],
        pageCount: data?.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    resourceRates,
    resourceRatesError: resourceRatesError || customError,
    resourceRatesLoading,
    pageMeta,
    resourceRatesRefetch: resourceRatesRefetch,
  };
};

export default useResourceRates;
